import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddManualUpdateComponent } from './add-manual-update/add-manual-update.component';
import { AddSingleManualUpdateComponent } from './add-single-manual-update/add-single-manual-update.component';

//const routes: Routes = [];

// @NgModule({
//   imports: [RouterModule.forChild(routes)],
//   exports: [RouterModule]
// })
// export class ManualUpdateRoutingModule { }
export const ManualUpdateRoutingModule: Routes = [{
  path: '',
  component: AddManualUpdateComponent,
  children: [
    {
      path: 'sigle-update',
      component: AddSingleManualUpdateComponent
    },
   
  ]
}];
